var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"external-link"},[_c('h2',{directives:[{name:"markdown",rawName:"v-markdown",value:(_vm.attributes.value.h2),expression:"attributes.value.h2"}]}),_vm._l((_vm.attributes.value.links),function(ref,i){
var href = ref.href;
var text = ref.text;
return _c('ul',{key:i,staticClass:"link"},[_c('li',[_c('a',{attrs:{"href":href,"target":"_blank"}},[_vm._v(_vm._s(text))])])])})],2)}
var staticRenderFns = []

export { render, staticRenderFns }